import moment from "moment";

export function NumberWithCommas(x: number | string) {
  if (!x) return "-";
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getFirstDayOfWeek(year: number, week: number) {
  let startOfYear = moment().year(year).startOf("year");
  let weekStart = startOfYear.add(week - 1, "weeks").startOf("isoWeek");

  return weekStart.format("YYYY-MM-DD");
}

export const getChartDatesFromRange = (
  startDate: Date,
  endDate: Date
): string[] => {
  const getDaysArray = function (s: Date, e: Date) {
    for (
      var a = [], d = new Date(s);
      d <= new Date(e);
      d.setDate(d.getDate() + 1)
    ) {
      a.push(moment(new Date(d)).format("ll"));
    }
    return a;
  };

  return getDaysArray(startDate, endDate);
};

export const isApplightDomain = () => {
  if (typeof window === "undefined") return false;
  const currentDomain = window.location.hostname;
  return currentDomain.includes("dashboard.applight.ai");
};

